export default "<ion-button\n    [expand]=\"expand\"\n    [disabled]=\"disabled\"\n    [type]=\"type\"\n>\n    <ng-content></ng-content>\n</ion-button>\n";